import { catchError, map } from 'rxjs/operators';
import { CertificatesService } from './../../core/services/certificates/certificates.service';
import { Component, Input, OnInit } from '@angular/core';
import { DropdownLists } from './../../core/helpers/dropdown-lists/dropdown-lists';
import { EmailService } from 'src/app/core/services/email/email.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { RoutingPath } from './../../configs/routing-path';
import { throwError } from 'rxjs';

@Component({
    selector: 'app-form-affiliation-summary',
    templateUrl: './form-affiliation-summary.component.html',
    styleUrls: ['./form-affiliation-summary.component.scss'],
    standalone: false
})
export class FormAffiliationSummaryComponent implements OnInit {

  @Input() affiliation: string;
  @Input() type: string;
  public sendEmail: string;
  public emailFormGroup: FormGroup;
  public afiliacion;
  public home;
  public downloading = false;
  public printing = false;
  public sending = false;
  public alert: string;
  public emailInvalido = false;
  
  public modalOpen = false;
  public modalType: 'success' | 'error' = 'success';
  public modalTitle = '';
  public modalMessage = '';

  tipoDocumento: { trabajador: string } = {
    trabajador: 'Certificado afiliación trabajadores'
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _certificateService: CertificatesService,
    private _emailService: EmailService) {
    this.emailFormGroup = this._formBuilder.group({});
    this.emailFormGroup.setControl('email', new FormControl(''));
  }

  ngOnInit() {
    this.afiliacion = '/' + RoutingPath.appRouting.components.invidivual_affiliation.path + '/' + RoutingPath.appRouting.components.invidivual_affiliation.pages.home.path;
    this.home = '/' + RoutingPath.appRouting.components.dashboard.path + '/' + RoutingPath.appRouting.components.dashboard.pages.home.path;
    this.tipoDocumento
  }

  async affiliationGenerate() {
    if (this.type === 'CUOTAM') {
      await this.sendEmailAffiliation(this.affiliation);
    } else {
      if (this.type === 'PERSON') {
        this.affiliationPerson();
      } else if (this.type === 'COMPANY') {
        this.affiliationCompany();
      }
    }
  }

  
  affiliationPerson() {
    this._certificateService.affiliationPerson(JSON.stringify(this.affiliation))
      .subscribe(async response => {
        if (response != null && response.body != null) {
          await this.sendEmailAffiliation(response.body);
        }
      });
  }

  affiliationCompany() {
    this._certificateService.affiliationCompany(JSON.stringify(this.affiliation))
      .subscribe(async response => {
        if (response != null && response.body != null) {
          await this.sendEmailAffiliation(response.body);
        }
      });
  }

  async sendEmailAffiliation(dataEncode: string) {
    const control = this.emailFormGroup.get('email');
    const email = control?.value ? String(control.value).trim() : '';

    
    if (!email) {
      return;
    }
    if (this.emailInvalido) {
      return;
    }

    this.sending = true;

    try {
      
      await this._emailService.postMail(
        this._emailService.initMail(dataEncode, email, 0)
      );

      
      this.openModal('success');
    } catch (e) {
      
      this.openModal('error');
    } finally {
      this.sending = false;

      
    }
  }

  printAffiliation() {
    this.downloading = true;
    if (this.type === 'CUOTAM') {
      const auxLink = document.createElement('a');
      document.body.appendChild(auxLink);
      const url = `data:application/pdf;base64,${this.affiliation}`;
      auxLink.href = url;
      auxLink.target = '_blank';
      auxLink.hidden = true;
      auxLink.setAttribute("aria-label", "true");
      auxLink.download = 'certificado cuota monetaria';
      auxLink.click();
      window.URL.revokeObjectURL(url);
      this.downloading = false;
    } else {
      this._certificateService.downloadCertificate(JSON.stringify(this.affiliation), this.type)
        .pipe(
          map((response) => { this.downloading = false; }),
          catchError((err) => {
            this.downloading = false;
            alert('El usuario del cual esta intentando descargar el certificado no esta afiliado a su empresa.');
            return throwError(() => err);
          })
        ).subscribe();
    }
  }

  printAffiliationWindow() {
    this.printing = true;

    if (this.type === 'CUOTAM') {
      const url = `data:application/pdf;base64,${this.affiliation}`;
      const pdfResult = this.affiliation;
      const pdfWindow = window.open('');
      pdfWindow.document.write('<iframe width=\'100%\' height=\'100%\' style=\'border: 0; margin:-10px;\' src=\'data:application/pdf;base64, ' + encodeURI(pdfResult) + '\'></iframe>');
      this.printing = false;
    } else {
      this._certificateService.downloadCertificateWindow(JSON.stringify(this.affiliation), this.type)
        .pipe(
          map((response) => { this.printing = false; }),
          catchError((err) => {
            this.printing = false;
            alert('El usuario del cual esta intentando descargar el certificado no esta afiliado a su empresa.');
            return throwError(() => err);
          })
        ).subscribe();
    }
  }

  onEmailBlur(): void {
    const control = this.emailFormGroup.get('email');
    const email = control?.value ? control.value.trim() : '';

    if (control) {
      control.setValue(email);
    }

    this.emailInvalido = email !== '' && !this.esEmailValido(email);
  }

  esEmailValido(email: string): boolean {
    if (!email) {
      return false;
    }

    const valor = email.trim();
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return regexEmail.test(valor);
  }

  onEmailInput(): void {
    const control = this.emailFormGroup.get('email');
    const email = control?.value ? control.value.trim() : '';

    if (control && control.value !== email) {
      control.setValue(email);
    }

    if (this.emailInvalido) {
      this.emailInvalido = false;
    }
  }

  openModal(type: 'success' | 'error'): void {
  this.modalType = type;

  if (type === 'success') {
    this.modalTitle = 'Envío exitoso';
    this.modalMessage = 'El documento ha sido enviado al correo electrónico que ingresaste';
  } else {
    this.modalTitle = 'Error enviando el correo';
    this.modalMessage = 'No fue posible enviar el documento. Inténtalo de nuevo.';
  }

  this.modalOpen = true;
  document.body.style.overflow = 'hidden'; 
}

closeModal(): void {
  this.modalOpen = false;
  document.body.style.overflow = ''; 
}

}
